let counter = 0;

export const nextReportAttemptId = (): number => {
  counter += 1;
  return counter;
};
